<template>
  <header class="bg-black p-4">
    <div class="container mx-auto flex items-center justify-between">
      <div class="flex items-center gap-4">
        <!-- Logo -->
        <div class="flex items-center">
          <ULink to="/" class="flex items-center">
            <img 
              src="/images/logo-dark.png" 
              alt="Tus Noticias Logo" 
              class="h-12"
            />
          </ULink>
        </div>
      </div>

      <!-- Navegación Desktop -->
      <nav class="hidden md:block">
        <ul class="flex gap-6 text-white">
          <li v-for="link in navigationLinks" :key="link.path">
            <NuxtLink :to="link.path" class="hover:text-yellow-400">
              {{ link.name }}
            </NuxtLink>
          </li>
        </ul>
      </nav>

      <!-- Botón móvil -->
      <button class="md:hidden text-white" @click="isMenuOpen = !isMenuOpen">
        <Icon
          :name="isMenuOpen ? 'heroicons:x-mark' : 'heroicons:bars-3'"
          class="w-6 h-6"
        />
      </button>
    </div>

    <!-- Menú móvil -->
    <Transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="transform -translate-x-full"
      enter-to-class="transform translate-x-0"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="transform translate-x-0"
      leave-to-class="transform -translate-x-full"
    >
      <div
        v-if="isMenuOpen"
        class="fixed inset-0 z-50 md:hidden"
        @click="isMenuOpen = false"
      >
        <div class="fixed inset-y-0 left-0 w-64 bg-black" @click.stop>
          <nav class="mt-16 px-4">
            <ul class="space-y-4 text-white">
              <li v-for="link in navigationLinks" :key="link.path">
                <NuxtLink
                  :to="link.path"
                  class="block py-2 hover:text-yellow-400"
                  @click="isMenuOpen = false"
                >
                  {{ link.name }}
                </NuxtLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Transition>
  </header>
</template>

<script setup lang="ts">
import { navigationLinks } from '~/utils/navigation'

const isMenuOpen = ref(false)

// Cerrar el menú cuando se cambia de ruta
watch(() => useRoute().fullPath, () => {
  isMenuOpen.value = false
})

// Prevenir scroll cuando el menú está abierto
watch(isMenuOpen, (value) => {
  if (value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
})

// Limpiar el estilo del body cuando se desmonta el componente
onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>

<style scoped>
/* Asegurarse de que el header esté por encima de otros elementos */
header {
  position: relative;
  z-index: 50;
}
</style>

